import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosPatch } from "./axios";
import { setFields } from "./state";

export const updateProcessDetail = createAsyncThunk("pipeline/updateProcessDetail", async (userData, thunkAPI) => {
  const { processLog } = userData;
  console.log(`thunkAPI.getState() ${JSON.stringify(thunkAPI.getState())}`);
  const token = thunkAPI.getState().mainReducer.activeUser.authToken;
  console.log(`token ${token}`);
  console.log(`processLog ${JSON.stringify(processLog)}`)
  return {
    response: await axiosPatch({
      url: `/process_details/${processLog.uuid}/`,
      data: processLog,
      token,
    }),
    userData,
  };
});

const initialState = { 
  requestingUpdateProcess: false,  
};

const pipelineSlice = createSlice({
  name: "pipeline",
  initialState,
  reducers: {
    
  },
  extraReducers: {
    //
    // updateProcessDetail
    //
    [updateProcessDetail.pending]: (state, action) => {
      setFields(state, { requestingUpdateProcess: true });
    },

    [updateProcessDetail.fulfilled]: (state, action) => {
      //const ignoreId = action.payload.userData.ignoreId;
      //const watchVideos = action.payload.response.data.data.filter((item) => item.sys.id != ignoreId);
      setFields(state, {        
        requestingUpdateProcess: false,
      });
    },

    [updateProcessDetail.rejected]: (state, action) => {
      console.error("updateProcessDetail API ERROR:", action.error);
      setFields(state, {
        errors: action.payload,
        requestingUpdateProcess: false,
      });
    },
  },
});

//export const {}= pipelineSlice.actions;
export default pipelineSlice.reducer;